import { useMemo } from "react";
import { object, string } from "yup";


export type CheckTelephoneCode = {
  mobileNumber: string;
  code: string;
};

const useValidationSchemaTelephoneCode = () => {
  return useMemo(() => {
    const requiredMessage = "form.error.notEmpty";

    // Schema représentant l'ensemble des champs du formulaire
    // inclu la validation de ces champs si nécessaire
    const validationSchema = object<CheckTelephoneCode>().shape({
      mobileNumber: string(),
      code: string().required(requiredMessage),
    });
    return validationSchema;
  }, []);
};

export default useValidationSchemaTelephoneCode;
